import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Filter, Ansicht und geoeffneter Eintrag stehen auf den Vertriebsseiten in
 * der URL, damit Links aus Akte, Cockpit und Aufgaben direkt dort landen.
 * Leere Werte entfernen den Parameter statt "?status=" zu hinterlassen.
 */
export function useUrlParams() {
  const [params, setParams] = useSearchParams();

  const setMany = useCallback((werte: Record<string, string | null | undefined>, opts?: { replace?: boolean }) => {
    const next = new URLSearchParams(params);
    Object.entries(werte).forEach(([name, wert]) => {
      if (wert) next.set(name, wert);
      else next.delete(name);
    });
    setParams(next, { replace: opts?.replace ?? false });
  }, [params, setParams]);

  const set = useCallback((name: string, wert: string | null | undefined, opts?: { replace?: boolean }) => {
    setMany({ [name]: wert }, opts);
  }, [setMany]);

  const get = useCallback((name: string) => params.get(name) ?? '', [params]);

  return { params, get, set, setMany };
}
